import { useSnapshot } from "valtio";
import { organizationStore } from "../../../store/OrganizationStore";
import { useState } from "react";
import { Organization } from "../../../shared/models/organization.model";
import { OrganizationService } from "../../../shared/services/organizations/OrganizationService";
import showAlert from "../../../shared/utils/generic";
import { errorMessage } from "../../../shared/utils/errorMessage";


const useOrganization = () => {

    useSnapshot(organizationStore);
    const { setIsdeleting, setModalDeleteVisible } = organizationStore;
	const [ organizationForm, setOrganizationForm ] = useState<Organization>(new Organization);
    const [ organizationSelected, setOrganizationSelected ] = useState<Organization>(new Organization);
	const service = new OrganizationService();
	const [isOrganizationLoading, setIsOrganizationLoading] = useState<boolean>(false);

	const create = async() =>{
		setIsOrganizationLoading(true);
		try {
			const response = await service.createOrganization(organizationForm);
			if(response) {
				organizationStore.setModalTemplateVisibility(false)
				showAlert("Organization created successfully", "success", 3000);
			}
		} catch(e){
			showAlert(errorMessage(e),"error",3000)
		} finally {
			setIsOrganizationLoading(false);
		}
	}
    
    const updateOrg = async() =>{
		setIsOrganizationLoading(true);
		try {
			await service.updateOrganization(organizationForm);
			showAlert("organization updated successfully","success",3000)
		} catch(e){
			showAlert(errorMessage(e),"error",3000)
		} finally {
			setIsOrganizationLoading(false);
		}
	}

    const deleteOrg = async (mode: "block" | "reparent" | "cascade" = "block") => {
		setIsdeleting(true);
		setIsOrganizationLoading(true);
		try{
			const response = await service.deleteOrganization(organizationSelected.id.toString(), mode);
			if(response) {
				setModalDeleteVisible(false);
				showAlert(response, "success", 3000);
				setIsdeleting(false)
			}
		} catch(e: any){
			const msg = errorMessage(e);
			showAlert(msg, "error", 4000);
			throw e;
		} finally {
			setIsOrganizationLoading(false);
		}
	}

	const getOrganization = async (organizationId: string) => {
		const response = await service.getOrganization(organizationId);
		try{
			if(response) {
				setOrganizationForm(response);
			}
		} catch(e){
			showAlert(errorMessage(e),"error",3000)
		} finally {
			setIsOrganizationLoading(false);
		}

	}

    return {
		create, updateOrg, deleteOrg, 
		organizationSelected, setOrganizationSelected,
		organizationForm, setOrganizationForm, 
		getOrganization, isOrganizationLoading 
	}
}

export default useOrganization;